/* eslint-disable no-param-reassign,no-prototype-builtins,no-loop-func */

import _ from 'lodash';

export const stepCancellationAdditionalExpenseLookup = {
  claimForTripCancellationExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCancellationAdditionalExpenseLookup.claimForTripCancellationExpenses.associatedClaimCodes,
  },
  claimForTripDisruptionOrAdditionalExpenses: {
    claimCode: VARS.BENEFIT_MAPPING.stepCancellationAdditionalExpenseLookup.claimForTripDisruptionOrAdditionalExpenses.claimCode,
  },
  claimForTripResumptionExpenses: {
    claimCode: VARS.BENEFIT_MAPPING.stepCancellationAdditionalExpenseLookup.claimForTripResumptionExpenses.claimCode,
  },
  claimForAlternativeTransportExpenses: {
    claimCode: VARS.BENEFIT_MAPPING.stepCancellationAdditionalExpenseLookup.claimForAlternativeTransportExpenses.claimCode,
  },
  claimForATravelDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCancellationAdditionalExpenseLookup.claimForATravelDelay.associatedClaimCodes,
  },
  claimForAdditionalExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCancellationAdditionalExpenseLookup.claimForAdditionalExpenses.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepCancellationAdditionalExpenseLookup.claimCodeList],
};

export const stepPersonalItemsExpenseLookup = {
  claimForDelayLuggage: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPersonalItemsExpenseLookup.claimForDelayLuggage.associatedClaimCodes,
  },
  claimForPassportCreditCard: {
    claimCode: VARS.BENEFIT_MAPPING.stepPersonalItemsExpenseLookup.claimForPassportCreditCard.claimCode,
  },
  claimForTheftOfCash: {
    claimCode: VARS.BENEFIT_MAPPING.stepPersonalItemsExpenseLookup.claimForTheftOfCash.claimCode,
  },
  claimForLuggageAndPersonalEffect: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPersonalItemsExpenseLookup.claimForLuggageAndPersonalEffect.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepPersonalItemsExpenseLookup.claimCodeList],
};

export const stepOverseasMedicalExpenseLookup = {
  areYouClaimingForEmergencyMedicalAndHospitalExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOverseasMedicalExpenseLookup.areYouClaimingForEmergencyMedicalAndHospitalExpenses.associatedClaimCodes,
  },
  areYouClaimingForLossOfIncome: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOverseasMedicalExpenseLookup.areYouClaimingForLossOfIncome.associatedClaimCodes,
  },

  claimCodeList: [...VARS.BENEFIT_MAPPING.stepOverseasMedicalExpenseLookup.claimCodeList],
};

export const stepRentalVehicleExpenseLookup = {
  areYouClaimingForRentalVehicleExcess: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepRentalVehicleExpenseLookup.areYouClaimingForRentalVehicleExcess.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepRentalVehicleExpenseLookup.claimCodeList],
};

export const stepSnowSportsExpenseLookup = {
  areYouClaimingForSnowSportEquipment: {
    claimCode: VARS.BENEFIT_MAPPING.stepSnowSportsExpenseLookup.areYouClaimingForSnowSportEquipment.claimCode,
  },
  areYouClaimingForSnowEquipmentReplacementHire: {
    claimCode: VARS.BENEFIT_MAPPING.stepSnowSportsExpenseLookup.areYouClaimingForSnowEquipmentReplacementHire.claimCode,
  },
  areYouClaimingForSnowPrepaidExpenses: {
    claimCode: VARS.BENEFIT_MAPPING.stepSnowSportsExpenseLookup.areYouClaimingForSnowPrepaidExpenses.claimCode,
  },
  areYouClaimingForSnowResortClosure: {
    claimCode: VARS.BENEFIT_MAPPING.stepSnowSportsExpenseLookup.areYouClaimingForSnowResortClosure.claimCode,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepSnowSportsExpenseLookup.claimCodeList],
};

export const stepOtherExpenseLookup = {
  areYouClaimingForPersonalLiability: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.areYouClaimingForPersonalLiability.associatedClaimCodes,
  },
  isThereAnyThingElseYouWouldLikeToClaimFor: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.isThereAnyThingElseYouWouldLikeToClaimFor.associatedClaimCodes,
  },
  areYouClaimingForAccidentalDeathAndDismemberment: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.areYouClaimingForAccidentalDeathAndDismemberment.associatedClaimCodes,
  },
  areYouClaimingForBurialExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.areYouClaimingForBurialExpenses.associatedClaimCodes,
  },
  areYouClaimingForRepatriationExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.areYouClaimingForRepatriationExpenses.associatedClaimCodes,
  },
  personalLiability: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.personalLiability.associatedClaimCodes,
  },
  personalAccident: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.personalAccident.associatedClaimCodes,
  },
  lossOfIncome: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.lossOfIncome.associatedClaimCodes,
  },
  totalPermanentDisablement: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.totalPermanentDisablement.associatedClaimCodes,
  },
  lossOfLife: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.lossOfLife.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepOtherExpenseLookup.claimCodeList],
};

export const stepTripCancellationAndTripInterruptionExpenseLookup = {
  tripCancellation: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellation.associatedClaimCodes,
  },
  tripCancellationForAnyReason: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellationForAnyReason.associatedClaimCodes,
  },
  travelInterruption: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationAndTripInterruptionExpenseLookup.travelInterruption.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList],
};

export const step17ExpenseLookup = {
  claimCodeList: [...VARS.BENEFIT_MAPPING.step17ExpenseLookup.claimCodeList],
};

export const stepBaggageAndPersonalItemsExpenseLookup = {
  areYouClaimingForDamaged: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsExpenseLookup.areYouClaimingForDamaged.associatedClaimCodes,
  },
  areYouClaimingForBaggageDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsExpenseLookup.areYouClaimingForBaggageDelay.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsExpenseLookup.claimCodeList],
};

export const stepMedicalExpensesExpenseLookup = {
  areYouClaimingForHospitalAndMedicalExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalExpensesExpenseLookup.areYouClaimingForHospitalAndMedicalExpenses.associatedClaimCodes,
  },
  areYouClaimingForUnexpectedRecurrence: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalExpensesExpenseLookup.areYouClaimingForUnexpectedRecurrence.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepMedicalExpensesExpenseLookup.claimCodeList],
};

export const stepPetMedicalExpenseLookup = {
  petMedical: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPetMedicalExpenseLookup.petMedical.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepPetMedicalExpenseLookup.claimCodeList],
};

export const stepCollisionDamageExpenseLookup = {
  collisionDamage: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCollisionDamageExpenseLookup.collisionDamage.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepCollisionDamageExpenseLookup.claimCodeList],
};

export const stepPropertyDamageExpenseLookup = {
  propertyDamage: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPropertyDamageExpenseLookup.propertyDamage.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepPropertyDamageExpenseLookup.claimCodeList],
};

export const stepMedicalExpenseLookup = {
  medicalExpense: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalExpenseLookup.medicalExpense.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepMedicalExpenseLookup.claimCodeList],
};

export const stepTripCancellationLookup = {
  tripCancellation: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationLookup.tripCancellation.associatedClaimCodes,
  },
  areYouClaimingForAirlineReissueOrCancellationFees: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationLookup.areYouClaimingForAirlineReissueOrCancellationFees.associatedClaimCodes,
  },
  areYouClaimingForReinstateFrequentTravelerAwards: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationLookup.areYouClaimingForReinstateFrequentTravelerAwards.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepTripCancellationLookup.claimCodeList],
};

export const stepTripInterruptionLookup = {
  tripInterruption: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripInterruptionLookup.tripInterruption.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepTripInterruptionLookup.claimCodeList],
};

export const stepTripDelayLookup = {
  travelDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripDelayLookup.travelDelay.associatedClaimCodes,
  },
  areYouClaimingForTripDelayPerDay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripDelayLookup.areYouClaimingForTripDelayPerDay.associatedClaimCodes,
  },
  areYouClaimingForKennelFeesAtHome: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripDelayLookup.areYouClaimingForKennelFeesAtHome.associatedClaimCodes,
  },
  areYouClaimingForKennelFeesOnTrip: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripDelayLookup.areYouClaimingForKennelFeesOnTrip.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepTripDelayLookup.claimCodeList],
};

export const stepAccidentalDeathAndDismembermentLookup = {
  areYouClaimingForAccidentalDeathAndDismemberment: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepAccidentalDeathAndDismembermentLookup.areYouClaimingForAccidentalDeathAndDismemberment.associatedClaimCodes,
  },
  areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepAccidentalDeathAndDismembermentLookup.areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepAccidentalDeathAndDismembermentLookup.claimCodeList],
};

export const stepMissedConnectionLookup = {
  areYouClaimingForMissedConnection: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMissedConnectionLookup.areYouClaimingForMissedConnection.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepMissedConnectionLookup.claimCodeList],
};

export const stepBaggageAndPersonalLookup = {
  areYouClaimingForDamaged: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalLookup.areYouClaimingForDamaged.associatedClaimCodes,
  },
  areYouClaimingForALostItem: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalLookup.areYouClaimingForALostItem.associatedClaimCodes,
  },
  areYouClaimingForValuables: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalLookup.areYouClaimingForValuables.associatedClaimCodes,
  },
  areYouClaimingForBaggageDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalLookup.areYouClaimingForBaggageDelay.associatedClaimCodes,
  },
  areYouClaimingForBaggageDelayPerDay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalLookup.areYouClaimingForBaggageDelayPerDay.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepBaggageAndPersonalLookup.claimCodeList],
};

export const stepSportsEquipmentLookup = {
  areYouClaimingForLostSportsEquipmentRental: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepSportsEquipmentLookup.areYouClaimingForLostSportsEquipmentRental.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepSportsEquipmentLookup.claimCodeList],
};

export const stepMedicalExpenseCFLookup = {
  medicalExpenseCF: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalExpenseCFLookup.medicalExpenseCF.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepMedicalExpenseCFLookup.claimCodeList],
};

export const stepTripCancellationCFLookup = {
  tripCancellation: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationCFLookup.tripCancellation.associatedClaimCodes,
  },
  tripCancellationForAnyReason: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationCFLookup.tripCancellationForAnyReason.associatedClaimCodes,
  },
  travelInterruption: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationCFLookup.travelInterruption.associatedClaimCodes,
  },
  travelDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTripCancellationCFLookup.travelDelay.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepTripCancellationCFLookup.claimCodeList],
};
export const baggagePersonalEffectsLookup = {
  areYouClaimingForDamaged: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.baggagePersonalEffectsLookup.areYouClaimingForDamaged.associatedClaimCodes,
  },
  areYouClaimingForBaggageDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.baggagePersonalEffectsLookup.areYouClaimingForBaggageDelay.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.baggagePersonalEffectsLookup.claimCodeList],
};
export const itineraryChangeLookup = {
  itineraryChange: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.itineraryChangeLookup.itineraryChange.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.itineraryChangeLookup.claimCodeList],
};
export const medicalHardshipLookup = {
  criticalIllness: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.medicalHardshipLookup.criticalIllness.associatedClaimCodes,
  },
  disability: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.medicalHardshipLookup.disability.associatedClaimCodes,
  },
  dismemberment: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.medicalHardshipLookup.dismemberment.associatedClaimCodes,
  },
  leaveOfAbsence: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.medicalHardshipLookup.leaveOfAbsence.associatedClaimCodes,
  },
  death: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.medicalHardshipLookup.death.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.medicalHardshipLookup.claimCodeList],
};
export const jobLossHardshipLookup = {
  jobLossHardship: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.jobLossHardshipLookup.jobLossHardship.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.jobLossHardshipLookup.claimCodeList],
};
export const disasterAssistanceHardshipLookup = {
  disasterAssistanceHardship: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.disasterAssistanceHardshipLookup.disasterAssistanceHardship.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.disasterAssistanceHardshipLookup.claimCodeList],
};
export const stepTravelDelayLookup = {
  travelDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTravelDelayLookup.travelDelay.associatedClaimCodes,
  },
  missedConnection: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepTravelDelayLookup.missedConnection.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepTravelDelayLookup.claimCodeList],
};
export const stepMedicalAndEvacuationLookup = {
  medicalHospitalExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.medicalHospitalExpenses.associatedClaimCodes,
  },
  wereYouHospitalisedForMoreThanThreeDaysYes: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.wereYouHospitalisedForMoreThanThreeDaysYes.associatedClaimCodes,
  },
  wereYouHospitalisedForMoreThanThreeDaysNo: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.wereYouHospitalisedForMoreThanThreeDaysNo.associatedClaimCodes,
  },
  didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWerehospitalised: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWerehospitalised.associatedClaimCodes,
  },
  dentalExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.dentalExpenses.associatedClaimCodes,
  },
  funeralExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.funeralExpenses.associatedClaimCodes,
  },
  wasTheDeathCausedByAnInjury: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.wasTheDeathCausedByAnInjury.associatedClaimCodes,
  },
  expensesArisingFromTerrorism: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.expensesArisingFromTerrorism.associatedClaimCodes,
  },
  opticalTreatment: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.opticalTreatment.associatedClaimCodes,
  },
  ancillaryServices: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.ancillaryServices.associatedClaimCodes,
  },
  mentalHealth: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.mentalHealth.associatedClaimCodes,
  },
  sexualHealth: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.sexualHealth.associatedClaimCodes,
  },
  extraTravelAndAccommodation: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.extraTravelAndAccommodation.associatedClaimCodes,
  },
  searchAndRescue: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.searchAndRescue.associatedClaimCodes,
  },
  urgentCareOutOfHoursvisits: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.urgentCareOutOfHoursvisits.associatedClaimCodes,
  },
  prescriptions: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.prescriptions.associatedClaimCodes,
  },
  GPVisits: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.GPVisits.associatedClaimCodes,
  },
  rehabilitationAndOccupationalTherapy: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.rehabilitationAndOccupationalTherapy.associatedClaimCodes,
  },
  maternityCare: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.maternityCare.associatedClaimCodes,
  },
  replacementStaff: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.replacementStaff.associatedClaimCodes,
  },
  repatriationBenefit: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.repatriationBenefit.associatedClaimCodes,
  },
  otherMedicalExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.otherMedicalExpenses.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepMedicalAndEvacuationLookup.claimCodeList],
};
export const stepChangesToYourJourneyLookup = {
  haveYouCanceledOrChangedYourJourneyBeforeLeaving: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.haveYouCanceledOrChangedYourJourneyBeforeLeaving.associatedClaimCodes,
  },
  wereYouDelayedWhileTravelingToASpecialEvent: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.wereYouDelayedWhileTravelingToASpecialEvent.associatedClaimCodes,
  },
  didYouCancelOrChangeYourTravelPlansDueToARelevantPerson: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson.associatedClaimCodes,
  },
  wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionYes: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionYes.associatedClaimCodes,
  },
  wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionNo: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionNo.associatedClaimCodes,
  },
  wereYouChargedACancellationFeeByTheTravelAgent: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.wereYouChargedACancellationFeeByTheTravelAgent.associatedClaimCodes,
  },
  haveYouChangedYourJourneyAfterLeaving: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.haveYouChangedYourJourneyAfterLeaving.associatedClaimCodes,
  },
  wereYouDelayedWhileTravelingToASpecialEventAL: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.wereYouDelayedWhileTravelingToASpecialEventAL.associatedClaimCodes,
  },
  wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL.associatedClaimCodes,
  },
  cuttingYourTripShortToReturnHome: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.cuttingYourTripShortToReturnHome.associatedClaimCodes,
  },
  travelInterruption: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.travelInterruption.associatedClaimCodes,
  },
  resumingYourTripBackOverseas: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.resumingYourTripBackOverseas.associatedClaimCodes,
  },
  petBoardingFacility: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.petBoardingFacility.associatedClaimCodes,
  },
  childCareExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.childCareExpenses.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepChangesToYourJourneyLookup.claimCodeList],
};

export const stepBaggageAndPersonalItemsSCTILookup = {
  baggageAndPersonalItems: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.baggageAndPersonalItems.associatedClaimCodes,
  },
  daggageDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.daggageDelay.associatedClaimCodes,
  },
  essentialMedication: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.essentialMedication.associatedClaimCodes,
  },
  jewelleryOrTraditionalWatches: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.jewelleryOrTraditionalWatches.associatedClaimCodes,
  },
  laptopsTabletsOrCameras: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.laptopsTabletsOrCameras.associatedClaimCodes,
  },
  laptopsTabletsOrCamerasNewThePolicy: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.laptopsTabletsOrCamerasNewThePolicy.associatedClaimCodes,
  },
  otherUnspecifiedTtems: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.otherUnspecifiedTtems.associatedClaimCodes,
  },
  specifiedHighValueItems: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.specifiedHighValueItems.associatedClaimCodes,
  },
  bankCardsOrTravelDocuments: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.bankCardsOrTravelDocuments.associatedClaimCodes,
  },
  cash: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.cash.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsSCTILookup.claimCodeList],
};

export const stepPersonalAccidentSCTILookup = {
  isThisClaimRelatedToPersonalAccident: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPersonalAccidentSCTILookup.isThisClaimRelatedToPersonalAccident.associatedClaimCodes,
  },
  isThisClaimRelatedToLossOfLifeCausedByAnInjury: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPersonalAccidentSCTILookup.isThisClaimRelatedToLossOfLifeCausedByAnInjury.associatedClaimCodes,
  },
  didTheInjuryLeaveYouPermanentlyDisabled: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPersonalAccidentSCTILookup.didTheInjuryLeaveYouPermanentlyDisabled.associatedClaimCodes,
  },
  didTheInjuryResultInYourInabilityToReturnToWork: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepPersonalAccidentSCTILookup.didTheInjuryResultInYourInabilityToReturnToWork.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepPersonalAccidentSCTILookup.claimCodeList],
};

export const stepRentalVehicleExcessSCTILookup = {
  rentalvehicleExcessbenefit: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepRentalVehicleExcessSCTILookup.rentalvehicleExcessbenefit.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepRentalVehicleExcessSCTILookup.claimCodeList],
};

export const stepCashBankCardsTravelDocumentsAndPassportsLookup = {
  baggageAndPersonalItems: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCashBankCardsTravelDocumentsAndPassportsLookup.baggageAndPersonalItems.associatedClaimCodes,
  },
  bankCardsOrTravelDocuments: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCashBankCardsTravelDocumentsAndPassportsLookup.bankCardsOrTravelDocuments.associatedClaimCodes,
  },
  cash: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCashBankCardsTravelDocumentsAndPassportsLookup.cash.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList],
};

export const stepChangesToYourJourneyTrawickLookup = {
  travelDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyTrawickLookup.travelDelay.associatedClaimCodes,
  },
  missedConnection: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyTrawickLookup.missedConnection.associatedClaimCodes,
  },
  tripCancellation: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyTrawickLookup.tripCancellation.associatedClaimCodes,
  },
  tripCancellationForAnyReason: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyTrawickLookup.tripCancellationForAnyReason.associatedClaimCodes,
  },
  travelInterruption: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepChangesToYourJourneyTrawickLookup.travelInterruption.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepChangesToYourJourneyTrawickLookup.claimCodeList],
};

export const stepBaggageAndPersonalItemsStarrLookup = {
  areYouClaimingForDamaged: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsStarrLookup.areYouClaimingForDamaged.associatedClaimCodes,
  },
  areYouClaimingForBaggageDelay: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsStarrLookup.areYouClaimingForBaggageDelay.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepBaggageAndPersonalItemsStarrLookup.claimCodeList],
};

export const stepOtherStarrLookup = {
  areYouClaimingForPersonalLiability: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherStarrLookup.areYouClaimingForPersonalLiability.associatedClaimCodes,
  },
  isThereAnyThingElseYouWouldLikeToClaimFor: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherStarrLookup.isThereAnyThingElseYouWouldLikeToClaimFor.associatedClaimCodes,
  },
  areYouClaimingForAccidentalDeathAndDismemberment: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherStarrLookup.areYouClaimingForAccidentalDeathAndDismemberment.associatedClaimCodes,
  },
  areYouClaimingForBurialExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherStarrLookup.areYouClaimingForBurialExpenses.associatedClaimCodes,
  },
  areYouClaimingForRepatriationExpenses: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepOtherStarrLookup.areYouClaimingForRepatriationExpenses.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepOtherStarrLookup.claimCodeList],
};

export const stepCollisionDamageStarrLookup = {
  collisionDamage: {
    claimCode: '',
    associatedClaimCodes: VARS.BENEFIT_MAPPING.stepCollisionDamageStarrLookup.collisionDamage.associatedClaimCodes,
  },
  claimCodeList: [...VARS.BENEFIT_MAPPING.stepCollisionDamageStarrLookup.claimCodeList],
};
export const stepMedicalExpensesTugoLookup = VARS.BENEFIT_MAPPING.stepMedicalExpensesTugoLookup;
export const stepOtherTugoLookup = VARS.BENEFIT_MAPPING.stepOtherTugoLookup;
export const stepBaseVictorsMedicalTugoLookup = VARS.BENEFIT_MAPPING.stepBaseVictorsMedicalTugoLookup;
export const stepStudentMedicalBenefitsTugoLookup = VARS.BENEFIT_MAPPING.stepStudentMedicalBenefitsTugoLookup;

export const listCodeForAuthorizationLookup = VARS.BENEFIT_MAPPING.listCodeForAuthorization;
export const listCodeForDuesProtect = VARS.BENEFIT_MAPPING.listCodeForDuesProtect;
export const listNameBenefitForDuesProtect = VARS.BENEFIT_MAPPING.listNameBenefitForDuesProtect;
export const listNameBenefitForTripCan = VARS.BENEFIT_MAPPING.listNameBenefitForTripCan;
export const defaultCountry = VARS.BENEFIT_MAPPING.defaultCountry;
export const listPolicyTypeForCellCaptiveSCTIAustralia = VARS.BENEFIT_MAPPING.listPolicyTypeForCellCaptiveSCTIAustralia;
export const listPolicyTypeForCellCaptiveSCTINewZealand = VARS.BENEFIT_MAPPING.listPolicyTypeForCellCaptiveSCTINewZealand;
export const listPolicyTypeForCellCaptivePartnerInsurance = VARS.BENEFIT_MAPPING.listPolicyTypeForCellCaptivePartnerInsurance;

export const emptyClaimCode = '';

const listCodeNeedToCovert = VARS.BENEFIT_MAPPING.listCodeNeedToCovert;

export const convertClaimCode = (claimTypes, policyTypeId) => {
  claimTypes.forEach((data) => {
    const rs = _.find(listCodeNeedToCovert, (x) => x.from.indexOf(data.claimCode) > -1);
    if (rs) {
      if (policyTypeId !== 58 || data.claimCode !== 'SC') {
        data.claimCode = rs.to;
      }
    }
  });
  return claimTypes;
};


export function configClaimCodeMapper(claimTypes, policyTypeId) {
  // The claimCodes cotnains the following format
  /*
    [{claimTypeId: '',
      description: '',
      claimCode: ''}]
  */
  const converted = convertClaimCode(claimTypes, policyTypeId);
  const expenses = [stepCancellationAdditionalExpenseLookup, stepPersonalItemsExpenseLookup, stepOverseasMedicalExpenseLookup, stepRentalVehicleExpenseLookup, stepOtherExpenseLookup,
    stepTripCancellationAndTripInterruptionExpenseLookup, stepBaggageAndPersonalItemsExpenseLookup, stepMedicalExpensesExpenseLookup, stepPetMedicalExpenseLookup, stepCollisionDamageExpenseLookup, stepPropertyDamageExpenseLookup,
    stepMedicalExpenseLookup, stepTripCancellationLookup, stepAccidentalDeathAndDismembermentLookup, stepTripInterruptionLookup, stepTripDelayLookup, stepMissedConnectionLookup, stepBaggageAndPersonalLookup, stepSportsEquipmentLookup,
    stepMedicalExpenseCFLookup, stepTripCancellationCFLookup, baggagePersonalEffectsLookup, itineraryChangeLookup,
    medicalHardshipLookup, jobLossHardshipLookup, disasterAssistanceHardshipLookup, stepTravelDelayLookup,
    stepMedicalAndEvacuationLookup, stepChangesToYourJourneyLookup, stepBaggageAndPersonalItemsSCTILookup, stepPersonalAccidentSCTILookup, stepRentalVehicleExcessSCTILookup, stepCashBankCardsTravelDocumentsAndPassportsLookup,
    stepChangesToYourJourneyTrawickLookup, stepBaggageAndPersonalItemsStarrLookup, stepOtherStarrLookup, stepCollisionDamageStarrLookup,
    stepMedicalExpensesTugoLookup, stepOtherTugoLookup, stepBaseVictorsMedicalTugoLookup, stepStudentMedicalBenefitsTugoLookup,
  ];
  expenses.forEach((expense) => {
    /*
    We need to dynamically update the Claim Code for the Expense that has multiple claim codes assigned,
    i.e. the Expense that has "associatedClaimCodes" property defined
    */
    // const containMutlipleClaimCodes = false;
    let expenseIndex = -1;
    const properties = Object.keys(expense);
    for (let i = 0; i < properties.length; i++) {
      if (expense[properties[i]].hasOwnProperty('associatedClaimCodes')) {
        // containMutlipleClaimCodes = true;
        expenseIndex = i;
        expense[properties[expenseIndex]].associatedClaimCodes.forEach((claimCode) => {
          const claimTypeFound = !!(_.find(converted, (o) => o.claimCode === claimCode));
          if (claimTypeFound) {
            expense[properties[expenseIndex]].claimCode = claimCode;
          }
        });
      }
    }

    // if (containMutlipleClaimCodes) {
    //   expense[properties[expenseIndex]].associatedClaimCodes.forEach((claimCode) => {
    //     const claimTypeFound = !!(_.find(claimTypes, (o) => o.claimCode === claimCode));
    //     if (claimTypeFound) {
    //       expense[properties[expenseIndex]].claimCode = claimCode;
    //     }
    //   });
    // }
  });
}




// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/claimCodeMapper.js